module.exports = __webpack_public_path__ + "static/desktop/img/diarybook-4.9ef4e527.png";